var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#02BD9C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.748 6.135c.282.22.335.631.12.92l-5.014 6.688a.636.636 0 01-.965.065l-2.7-2.754a.665.665 0 010-.928.634.634 0 01.908 0l2.181 2.225 4.569-6.094a.634.634 0 01.9-.122z",
    fill: "#02BD9C"
  })));
}

SvgSuccess.displayName = 'Success';
export default SvgSuccess;